// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"f79bcb0b6afb4cc192a3","655":"ebec8bf2b1fe840033c6"}[chunkId] + ".js";
};